document.addEventListener('DOMContentLoaded', function () {
  const selectElement = document.getElementById('mySelect');
  const savedValue = localStorage.getItem('selectedOption');
  const savedClass = localStorage.getItem('selectedClass');

  let newChildActiveCount = 0; // Counter to track when "new-child-active" is applied

  // Show alert with saved value if it exists and apply your custom function
  if (savedValue) {
    selectElement.value = savedValue;

    // Apply custom function based on the saved value
    $(".custom-inner-wholesaler").find('.cc' + savedValue).parent().addClass("my-child-active");
    $(".custom-inner-wholesaler").find(".myccc").removeClass("new-child-active");

    setTimeout(function () {
      $(".custom-inner-wholesaler").find('.cc' + savedValue).addClass("new-child-active");
    }, 5);
  }

  if (savedClass) {
    const savedElement = document.querySelector(`.${savedClass}`);
    if (savedElement) {
      savedElement.classList.add('custom-activated');
    }
  }

  // Event listener for each .myccc item
  const items = document.querySelectorAll('.myccc');
  items.forEach(item => {
    item.addEventListener('click', function () {
      // Remove 'custom-activated' from all items
      items.forEach(i => i.classList.remove('custom-activated'));

      // Add 'custom-activated' to the clicked item
      item.classList.add('custom-activated');

      // Show alert with clicked element's text
      const clickedText = item.querySelector('.mygrand-child').textContent.trim();
      //alert(`${clickedText}`);
//document.getElementById('note').value = clickedText;
      // Store the selected class in localStorage
      localStorage.setItem('selectedClass', item.classList[2]);
    });
  });

  // Apply the previously selected option from the dropdown
  setTimeout(function () {
    checkAndClickSelection();
  }, 300);

  // Event listener for dropdown change
  // selectElement.addEventListener('change', function () {
  //   const newValue = selectElement.value;

  //   // Remove the old value from localStorage
  //   localStorage.removeItem('selectedOption');

  //   // Store the new selected value
  //   localStorage.setItem('selectedOption', newValue);

  //   // Apply custom function based on the new value
  //   $(".custom-inner-wholesaler").find('.cc' + newValue).parent().addClass("my-child-active");
  //   $(".custom-inner-wholesaler").find(".myccc").removeClass("new-child-active");

  //   setTimeout(function () {
  //     $(".custom-inner-wholesaler").find('.cc' + newValue).addClass("new-child-active");
  //   }, 5);
  // });

  // Listen for the application of "new-child-active" class and count how many times it has been applied
  const checkActiveClass = () => {
    const activeElement = document.querySelector('.new-child-active');
    if (activeElement) {
      // Increment the count when "new-child-active" is applied
      newChildActiveCount++;
      if (newChildActiveCount === 3) {
        const spanValue = activeElement.querySelector('.mygrand-child').textContent.trim();
        localStorage.setItem('activeSpanValue', spanValue);
        newChildActiveCount = 0; 
      }
    }
  };
  setInterval(checkActiveClass, 100);

});

function checkAndClickSelection() {
  const selectElement = document.getElementById('mySelect');
  const selectedValue = selectElement.value;
  if (selectedValue) {
    setTimeout(() => {
      const optionToClick = document.querySelector(`.custom-option .${selectedValue}`);
      if (optionToClick) {
        optionToClick.click();
      }
    }, 50);
  }
}

checkAndClickSelection();
document.getElementById('mySelect').addEventListener('change', checkAndClickSelection);
//document.getElementById('note').value = spanValue;




const selectElement = document.querySelector('#mySelect2');

// Add event listener for changes
selectElement.addEventListener('change', function () {
  const newValue = selectElement.value;
  // Remove the old value from localStorage
  localStorage.removeItem('selectedOption');

  // Store the new selected value
  localStorage.setItem('selectedOption', newValue);

  // Apply custom function based on the new value
  $(".custom-inner-wholesaler").find('.cc' + newValue).parent().addClass("my-child-active");
  $(".custom-inner-wholesaler").find(".myccc").removeClass("new-child-active");

  setTimeout(function () {
    $(".custom-inner-wholesaler").find('.cc' + newValue).addClass("new-child-active");
  }, 5);
});

// Programmatically change the option and dispatch the event
function changeSelectOption(newOptionValue) {
  selectElement.value = newOptionValue;

  // Dispatch the change event
  const event = new Event('change');
  selectElement.dispatchEvent(event);
}

// Example: Change #mySelect2 to a specific value
changeSelectOption('desiredOptionValue');


const selectElement3 = document.querySelector('#mySelect');

// Add event listener for changes
selectElement3.addEventListener('change', function () {
  const newValue = selectElement3.value;
  // Remove the old value from localStorage
  localStorage.removeItem('selectedOption');

  // Store the new selected value
  localStorage.setItem('selectedOption', newValue);

  // Apply custom function based on the new value
  $(".custom-inner-wholesaler").find('.cc' + newValue).parent().addClass("my-child-active");
  $(".custom-inner-wholesaler").find(".myccc").removeClass("new-child-active");

  setTimeout(function () {
    $(".custom-inner-wholesaler").find('.cc' + newValue).addClass("new-child-active");
  }, 5);
});

// Programmatically change the option and dispatch the event
function changeSelectOption(newOptionValue) {
  selectElement3.value = newOptionValue;

  // Dispatch the change event
  const event = new Event('change');
  selectElement3.dispatchEvent(event);
}

// Example: Change #mySelect2 to a specific value
changeSelectOption('desiredOptionValue');



